export const smartTagKeys = {
  all: ['smart-tags'] as const,
  many: (queryProps?: any) => [...smartTagKeys.all, 'list'].concat(queryProps ?? []),
  one: (id: number | null) => [...smartTagKeys.all, 'detail', id] as const,
};

export const tagPreviewPackagesKeys = {
  all: ['tag-preview-packages'] as const,
  one: (id: number | null) => [...tagPreviewPackagesKeys.all, 'detail', id] as const,
};
